import request from '@/utils/request.js';
import Qs from 'qs';

/**
 * 安全检查服务
 */
export class SecurityCheckControllerSvr {
    constructor() {
        this.baseurl = 'SecurityCheckControllerSvr.assx/';
    }

    /**
     * 按行政区域统计 四种检查情况信息
     * token:String, theme:String, startIndex:int, size:int
     */
    GetSecurityNameList(token, theme, startIndex, size){
        return request.post(this.baseurl + 'GetSecurityNameList', Qs.stringify({ token:token, theme:theme, startIndex:startIndex, size:size }));
    }

    /**
     * 项目经理 获取安全检查列表
     * token:String, type:int, theme:String, startIndex:int, size:int, areaStatus:int
     */
    getOrgMgeSecurityCheckTaskList(token, type, theme, startIndex, size, areaStatus){
        return request.post(this.baseurl + 'getOrgMgeSecurityCheckTaskList', Qs.stringify({ token:token, type:type, theme:theme, startIndex:startIndex, size:size, areaStatus:areaStatus }));
    }

    /**
     * 提交物业区域安全检查
     * token:String, SecurityCheckAreaId:String, status:int, securityCheckId:String, data:SecurityCheckMoldList
     */
    ModifySecurityCheckAreaEx(token, SecurityCheckAreaId, status, securityCheckId, data){
        return request.post(this.baseurl + 'ModifySecurityCheckAreaEx', Qs.stringify({ token:token, SecurityCheckAreaId:SecurityCheckAreaId, status:status, securityCheckId:securityCheckId, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 编辑检查类型
     * token:String, data:SecurityCheck
     */
    ModifySecurityCheck(token, data){
        return request.post(this.baseurl + 'ModifySecurityCheck', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取检查类型详情
     * token:String, keyId:String, isDetail:boolean
     */
    GetSecurityCheck(token, keyId, isDetail){
        return request.post(this.baseurl + 'GetSecurityCheck', Qs.stringify({ token:token, keyId:keyId, isDetail:isDetail }));
    }

    /**
     * 获取最近安全检查和专项检查的列表
     * token:String, size:int
     */
    GetNextSecurityCheck(token, size){
        return request.post(this.baseurl + 'GetNextSecurityCheck', Qs.stringify({ token:token, size:size }));
    }

    /**
     * 返回首页安全生产模块数据
     * token:String, eaAreaCode:String
     */
    GetSecurityCheckStaData(token, eaAreaCode){
        return request.post(this.baseurl + 'GetSecurityCheckStaData', Qs.stringify({ token:token, eaAreaCode:eaAreaCode }));
    }

    /**
     * 新增检查类型
     * token:String, data:SecurityCheck
     */
    AddSecurityCheck(token, data){
        return request.post(this.baseurl + 'AddSecurityCheck', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 发布安全检查
     * token:String, data:SecurityCheckTask
     */
    PublishSecurityCheck(token, data){
        return request.post(this.baseurl + 'PublishSecurityCheck', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取小区上次安全检查得分
     * token:String, eaAreaCode:String, detail:boolean
     */
    GetEaAreaLastCheckInfo(token, eaAreaCode, detail){
        return request.post(this.baseurl + 'GetEaAreaLastCheckInfo', Qs.stringify({ token:token, eaAreaCode:eaAreaCode, detail:detail }));
    }

    /**
     * 获取物业区域安全检查列表
     * token:String, securityCheckId:String, enterpriseId:String, status:int, startIndex:int, maxSize:int, totalCount:boolean, option:boolean
     */
    GetSecurityCheckAreaList(token, securityCheckId, enterpriseId, status, startIndex, maxSize, totalCount, option){
        return request.post(this.baseurl + 'GetSecurityCheckAreaList', Qs.stringify({ token:token, securityCheckId:securityCheckId, enterpriseId:enterpriseId, status:status, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount, option:option }));
    }

    /**
     * 删除安全检查模板
     * token:String, keyId:String
     */
    DeleteSecurityCheck(token, keyId){
        return request.post(this.baseurl + 'DeleteSecurityCheck', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 二级页面统计，统计完成和截止的安全检查每个行政区域 完成情况和合格率，如果传入keyId,则统计某一次检查的信息
     * token:String, keyId:String
     */
    GetSecurityStatisMap(token, keyId){
        return request.post(this.baseurl + 'GetSecurityStatisMap', Qs.stringify({ token:token, keyId:keyId }));
    }

    /**
     * 提交物业区域安全检查
     * token:String, data:SecurityCheckArea
     */
    ModifySecurityCheckArea(token, data){
        return request.post(this.baseurl + 'ModifySecurityCheckArea', Qs.stringify({ token:token, data:typeof data === 'undefined' || data === null ? '' : data.toString() }));
    }

    /**
     * 获取当前进行的安全检查任务
     * token:String
     */
    GetDoingSecurityCheckTask(token){
        return request.post(this.baseurl + 'GetDoingSecurityCheckTask', Qs.stringify({ token:token }));
    }

    /**
     * 修改安全检查模板 启动状态
     * token:String, keyId:String, used:boolean
     */
    UpdateSecurityCheckStatus(token, keyId, used){
        return request.post(this.baseurl + 'UpdateSecurityCheckStatus', Qs.stringify({ token:token, keyId:keyId, used:used }));
    }

    /**
     * 获取检查类型列表
     * token:String, typeName:String, manageType:int, status:int, startIndex:int, maxSize:int, totalCount:boolean
     */
    GetSecurityCheckList(token, typeName, manageType, status, startIndex, maxSize, totalCount){
        return request.post(this.baseurl + 'GetSecurityCheckList', Qs.stringify({ token:token, typeName:typeName, manageType:manageType, status:status, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount }));
    }

    /**
     * 获取安全检查详情
     * token:String, keyId:String, isDetail:boolean
     */
    GetSecurityCheckTask(token, keyId, isDetail){
        return request.post(this.baseurl + 'GetSecurityCheckTask', Qs.stringify({ token:token, keyId:keyId, isDetail:isDetail }));
    }

    /**
     * 获取物业区域安全检查详情
     * token:String, keyId:String, isDetail:boolean, type:int
     */
    GetSecurityCheckArea(token, keyId, isDetail, type){
        return request.post(this.baseurl + 'GetSecurityCheckArea', Qs.stringify({ token:token, keyId:keyId, isDetail:isDetail, type:type }));
    }

    /**
     * 获取安全检查列表
     * token:String, type:String, theme:String, date:String, enterpriseId:String, startIndex:int, maxSize:int, totalCount:boolean, option:boolean, status:int
     */
    GetSecurityCheckTaskList(token, type, theme, date, enterpriseId, startIndex, maxSize, totalCount, option, status){
        return request.post(this.baseurl + 'GetSecurityCheckTaskList', Qs.stringify({ token:token, type:type, theme:theme, date:date, enterpriseId:enterpriseId, startIndex:startIndex, maxSize:maxSize, totalCount:totalCount, option:option, status:status }));
    }

    /**
     * 按行政区域统计 四种检查情况信息
     * token:String, keyId:String
     */
    GetSecurityStatisMapByCantonCode(token, keyId){
        return request.post(this.baseurl + 'GetSecurityStatisMapByCantonCode', Qs.stringify({ token:token, keyId:keyId }));
    }
}